const FETCH_SPECIAL_REQUEST = 'FETCH_SPECIAL_REQUEST';
const FETCH_SPECIAL_SUCCESS = 'FETCH_SPECIAL_SUCCESS';
const FETCH_SPECIAL_FAILURE = 'FETCH_SPECIAL_FAILURE';

export { FETCH_SPECIAL_REQUEST, FETCH_SPECIAL_SUCCESS, FETCH_SPECIAL_FAILURE };
